import * as actionTypes from './actionTypes';
import * as baseAction from './baseAction';

export const mlsProviderStart = (accessToken, data) => baseAction.actionStart(actionTypes.MLSPROVIDER_START, accessToken, data);
export const mlsProviderSuccess = (data) => baseAction.actionSuccess(actionTypes.MLSPROVIDER_SUCCESS, data);
export const mlsProviderFail = (error) => baseAction.actionFail(actionTypes.MLSPROVIDER_FAIL, error);

export const mlsProviderSelect = (options) => {
  return (dispatch, getState) => {
    if (options && options.mlsProviderId) {
      baseAction.actionExecute(dispatch, getState, {
        url: `/MlsProvider/${options.mlsProviderId}`,
        startFn: (accessToken) => dispatch(mlsProviderStart(accessToken, { lastScope: 'select' })),
        successFn: (response) => dispatch(mlsProviderSuccess({ mlsProvider: response.data, isNew: false })),
        failFn: (error) => dispatch(mlsProviderFail(error))
      });
    } else {
      dispatch(mlsProviderSuccess({ mlsProvider: null, isNew: true }));
    }
  };
};

export const mlsProviderList = (options) => {
  return (dispatch, getState) => {
    let url = '/MlsProvider';

    if (options) {
      if (options.franchiseId) {
        url += `/Franchise/${options.franchiseId}`;
      } else if (options.branchOfficeId) {
        url += `/BranchOffice/${options.branchOfficeId}`;
      }
    }
  
    baseAction.actionExecute(dispatch, getState, {
      url: url,
      startFn: (accessToken) => dispatch(mlsProviderStart(accessToken, { lastScope: 'list' })),
      successFn: (response) => dispatch(mlsProviderSuccess({ mlsProviders: response.data })),
      failFn: (error) => dispatch(mlsProviderFail(error))
    });
  };
};

export const mlsProviderCreate = (options) => {
  return (dispatch, getState) => {
    let { logoFile, ...rest } = options.data;

    let url = '/MlsProvider';

    if (options) {
      if (options.franchiseId) {
        url += `/Franchise/${options.franchiseId}`;
      } else if (options.branchOfficeId) {
        url += `/BranchOffice/${options.branchOfficeId}`;
      }
    }

    baseAction.actionExecute(dispatch, getState, {
      type: 'create',
      multiPart: true,
      files: (logoFile) ? [logoFile] : null,
      url: url,
      payload: rest,
      startFn: (accessToken) => dispatch(mlsProviderStart(accessToken, { lastScope: 'create' })),
      successFn: (response) => dispatch(mlsProviderSuccess({ mlsProvider: response.data, isNew: false })),
      failFn: (error) => dispatch(mlsProviderFail(error))
    });
  };
};

export const mlsProviderUpdate = (options) => {  
  return (dispatch, getState) => {    
    let { logoFile, ...rest } = options.data;

    let url = `/MlsProvider/${options.mlsProviderId}`;

    if (options.franchiseId) {
      url += `/Franchise/${options.franchiseId}`;
      logoFile = null;
    } else if (options.branchOfficeId) {
      url += `/BranchOffice/${options.branchOfficeId}`;
      logoFile = null;
    }

    baseAction.actionExecute(dispatch, getState, {
      type: 'update',
      multiPart: true,
      files: (logoFile) ? [logoFile] : null,
      url: url,
      payload: rest,
      startFn: (accessToken) => dispatch(mlsProviderStart(accessToken, { lastScope: 'update' })),
      successFn: (response) => dispatch(mlsProviderSuccess({ mlsProvider: response.data, isNew: false })),
      failFn: (error) => dispatch(mlsProviderFail(error))
    });
  };
};

export const mlsProviderDelete = (options) => {
  return (dispatch, getState) => {
    let url = `/MlsProvider/${options.mlsProviderId}`;

    if (options) {
      if (options.franchiseId) {
        url += `/Franchise/${options.franchiseId}`;
      } else if (options.branchOfficeId) {
        url += `/BranchOffice/${options.branchOfficeId}`;
      }
    }

    baseAction.actionExecute(dispatch, getState, {
      type: 'delete',
      url: url,
      startFn: (accessToken) => dispatch(mlsProviderStart(accessToken, { lastScope: 'delete' })),
      successFn: (response) => dispatch(mlsProviderSuccess({ mlsProvider: null, isNew: false })),
      failFn: (error) => dispatch(mlsProviderFail(error))      
    });
  };
};
